module.exports = __webpack_public_path__ + "63fd19c4b7da6de0dbcb868ff50348e5.woff";